// components/RatingSection/RatingSection.tsx
import React from 'react';
import StarRating from '../RatingSeeker';
import styles from './index.module.scss';
import { calculateOverallRating } from '../../../../../utils/commonFunctions';
import SeekerDetails from '../..';

interface RatingItem {
  id: number;
  programRegistrationId: string;
  rmId: number;
  ratingKey: string;
  rating: string;
}

interface RatingSectionProps {
  ratings: RatingItem[];
  rmData: Record<string, any>;
  rmReview: string;
  rmReviewer?: string;
  rmName?: string; // Optional prop for RM name
}

const RatingSection: React.FC<RatingSectionProps> = ({ ratings, rmData, reviewer, rmReview }) => {
  // Calculate overall rating
  const overallRating = ratings.length > 0
    ? (ratings.reduce((acc, curr) => acc + Number(curr.rating), 0) / ratings.length).toFixed(1)
    : "0";

  // Rating categories to display
  const ratingCategories = [
    { key: 'passion', label: 'Passion' },
    { key: 'growth', label: 'Growth' },
    { key: 'Infinitheist', label: 'Infinitheist' },
    { key: 'continuity', label: 'Continuity' }
  ];
  console.log("reviewwww", rmData);
  return (
    <div className={styles.ratingSection}>
      <h3> {rmData.fullName}'s  review</h3>
      {/* <div className={styles.reviewerText}>{reviewer}</div> */}

      {ratings.length > 0 ? (
        <>
          <div className={styles.ratingDetails}>
            <div className={styles.overallRating}>
              <span className={styles.ratingLabel}>Overall rating is</span>
              <span className={styles.ratingScore}>{calculateOverallRating(ratings)}</span>
            </div>

            <div className={styles.ratingCategories}>
              {ratingCategories.map((category) => {
                const ratingValue = ratings.find(
                  r => r.ratingKey.toLowerCase() === category.key.toLowerCase()
                )?.rating || "0";

                return (
                  <div key={category.key} className={styles.ratingCategory}>
                    <span className={styles.categoryLabel}>{category.label}</span>
                    <StarRating count={Number(ratingValue)} />
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.rmReview}>
            <span className={styles.reviewLabel}>Comment</span>
            <p className={styles.reviewText}>{rmReview || ""}</p>
          </div>
        </>
      ) : (
        <div>
          Yet to review
        </div>
      )}
    </div>
  );
};

export default RatingSection;
